import React, {useEffect, useState} from 'react';

import Box from "@mui/material/Box";
import Moment from "react-moment";
import {IAttendee} from "./Buxliest";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from '@mui/icons-material/Delete';
import axios, {AxiosPromise} from "axios";
import Config from "../../utils/Config";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

export interface ISchedulCheckinAttendeeProps {
  attendee: IAttendee;
  onChange: any;
}

const SchedulCheckinAttendee = (props: ISchedulCheckinAttendeeProps) => {

  const checkinAttendee = () : AxiosPromise => {
    return axios({
      url: Config.getDrupalVar('path.baseRoot') + Config.getDrupalVar('path.baseUrl') + 'jsonapi/bux_attendee/bux_attendee/' + props.attendee.id,
      params: {
      },
      data: {
        data: {
          type: "bux_attendee--bux_attendee",
          id: props.attendee.id,
          attributes: {
            checkin: !props.attendee.checkin
          }
        }
      },
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'Accept': 'application/vnd.api+json',
      },
    });
  }

  const handleChange = () => {
    checkinAttendee().then((response) => {
      console.log('response delete item', response);
      props.attendee.checkin = !props.attendee.checkin;
      props.onChange(props.attendee, !props.attendee.checkin);
    })
  };

  const name = props.attendee.field_address.family_name + ", " +props.attendee.field_address.given_name;

  return (
      <Box className="flex flex-col">
        <Box>
          <FormControlLabel
            label={name}
            control={<Checkbox checked={props.attendee.checkin} onChange={handleChange} />}
          />
        </Box>
        {props.attendee.remark && (
          <Box className="text-gray-500">Anmerkung: {props.attendee.remark}</Box>
        )}
      </Box>
  );
};
export default SchedulCheckinAttendee;
